import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";

import { SvgIcon } from "../SvgIcon";

const LOGO_REFERENCE = "PlayHorizontalLockupCompact";

export function PlayHorizontalLockupCompact({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent(LOGO_REFERENCE);
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 115 48"
      sx={mergeSx({ w: "200px", fill: "base.color.brand.1" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}
PlayHorizontalLockupCompact.displayName = LOGO_REFERENCE;
